/** PURE_IMPORTS_START  PURE_IMPORTS_END */
"use strict";
/*@__PURE__*/ Object.defineProperty(exports, "__esModule", { value: true });
var errorObject_1 = /*@__PURE__*/ require("./errorObject");
var tryCatchTarget;
function tryCatcher() {
    try {
        return tryCatchTarget.apply(this, arguments);
    }
    catch (e) {
        errorObject_1.errorObject.e = e;
        return errorObject_1.errorObject;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}
exports.tryCatch = tryCatch;
